module.exports = __webpack_public_path__ + "img/tuceng18.8701cda6.png";